import { useState, useRef } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputTextArea from "../../helpers/InputTextArea";
import InputCombo from "../../helpers/InputCombo";
import InputDecimal from "../../helpers/InputDecimal";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputDate from "../../helpers/InputDate";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputPESEL from "../../helpers/InputPESEL";
import InputText from "../../helpers/InputText";
import InputPhone from "../../helpers/InputPhone";
import InputEmail from "../../helpers/InputEmail";

import back from "../../back.png";
import InputComboGrupa from "../../helpers/InputComboGrupa";



function NoticeCreate(props)
{
    
    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [emps, setEmps] = useState(null); //pracownicy..



    const [row, setRowX] = useState({
         id: props.row.id,
         numer_zgloszenia: props.row.numer_zgloszenia,
         imie: props.row.imie,
         nazwisko: props.row.nazwisko,
         data_urodzenia: props.row.data_urodzenia,
         miasto: props.row.miasto,
         ulica: props.row.ulica,
         nr_domu: props.row.nr_domu,
         nr_mieszkania: props.row.nr_mieszkania,
         kod_pocztowy: props.row.kod_pocztowy,
         proponowana_data_przyjecia: props.row.proponowana_data_przyjecia,
         telefon_kontaktowy: props.row.telefon_kontaktowy,
         e_mail: props.row.e_mail,
         status: props.row.status,
         created_at: props.row.created_at,
         kwota_wpisowa: props.row.kwota_wpisowa,
         kwota_zaplacona: props.row.kwota_zaplacona,

         powiadomienie: '_x_',

         uwagi_rekruta: props.row.uwagi_rekruta,
         p_subkonta_id: props.row.p_subkonta_id,

         r1_imie: props.row.r1_imie,
         r1_nazwisko: props.row.r1_nazwisko,
         r1_email: props.row.r1_email,
         r1_telefon: props.row.r1_telefon,

         r2_imie: props.row.r2_imie,
         r2_nazwisko: props.row.r2_nazwisko,
         r2_email: props.row.r2_email,
         r2_telefon: props.row.r2_telefon,

         pesel: props.row.pesel, 

         p_grupa_id: '_x_',

       
     });
     var tmpRow = row;




     const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const valChangeListener = (filedName, val, correct, msg) => {         
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
      
      
        tmpRow[filedName] = val;
        tmpRow[filedName+"_valid"] = correct;         
        setRowX(  JSON.parse(JSON.stringify(tmpRow)) );    
    
        //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );    


     
    }   


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const saveData = () => {




        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
    

        props.mainView.setProgress(-2);

        var req = row;

        fetch( Config.url + '/rest_v1_kids,notice_online_create_kid', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Dziecko zostało utworzone", "ok" , (param) => {
                            props.onSuccess();
                        } );                                                                  
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }

    

        return <div className="view_content">

                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

                    <h1><PlTitle userData={props.userData} /> / {row.numer_zgloszenia} / {row.imie} {row.nazwisko}</h1>


                    <form className="eForm bg_center">
                        
                                    <div className="form_tab">

                                        <div className="form_control">
                                                <div className="fieldName">Grupa*</div>
                                                <InputComboGrupa    userData={props.userData} value={row.p_grupa_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={""} className='   ' req='1' firstUp="1" />
                                        </div>

                                    </div>

                                    <div className="form_split"></div>

                                        <div className="form_btn">
                                                <div className="btn" onClick={saveData}>utwórz i dodaj do grupy</div>
                                                &nbsp;&nbsp;
                                                <div className="btn" onClick={props.onBack}    > anuluj</div>
                                        </div>

                    </form>

        </div>

}



export default NoticeCreate;